import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosHttp from 'services/axiosHttp';
import { message } from 'antd';

// action
export const updateQrLocation = createAsyncThunk("updateQrLocation", async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.patch('/lcqr/updateqrlocation', 
        { 
          qr_id: id,
          qr_name: data.qr_name,
          remark: data.remark || ''
        }
      );
      message.success('QR location updated successfully!');
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const QrLocationUpdateSlice = createSlice({
  name: 'QrLocationUpdateSlice',
  initialState: {
    isLoading: false,
    isError: false,
    error: null,
    data: null,
  },

  reducers: {
    resetUpdateState: (state) => {
      state.isLoading = false;
      state.error = false;
      state.data = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(updateQrLocation.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    });

    builder.addCase(updateQrLocation.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.data = action.payload;
    });

    builder.addCase(updateQrLocation.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    });
  },
});

export const { resetUpdateState } = QrLocationUpdateSlice.actions;
export default QrLocationUpdateSlice.reducer;
